import { useCallback } from "react";
import { useWorkOrderStore } from "../../store/wo-order";
import { useLocation } from "react-router";
import { getCustomColumnsWithGroup } from "../../api/WorkOrders";

export default function useGetCustomColumns() {
  const setCustomFields = useWorkOrderStore((state) => state.setCustomFields);
  const isRequester = useLocation().pathname.includes("requester");

  const getCustomColumns = useCallback(async () => {
    const response = await getCustomColumnsWithGroup(
      isRequester ? "mob_requester" : "mob_wo_nb_quick"
    );
    if (!response.isError) {
      const customFields = Object.keys(response.data.fields).map((key) => {
        const fieldValue = response.data.fields[key];

        return {
          ...fieldValue,
          filteredValues: fieldValue.ValidValues,
        };
      });

      setCustomFields(customFields);
    }
    return response;
  }, [isRequester, setCustomFields]);

  return { getCustomColumns };
}
